import React from 'react';
import clientInformation from '../login/ClientInfo';
import { RequestEWalletPayout, GetPayoutFee, CoinflowRegisterUser, CoinflowGetWithdrawer } from "../../services/PayoutService";
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import Loading from '../helpers/Loader';
import { IsValidToken } from "../../services/AuthenticationService";
import { onlyNumbers } from '../helpers/common';
import { isMobile } from 'react-device-detect';
import swal from 'sweetalert2';

export const PayoutRTPMethods = () => {
    const clientInfo = clientInformation();
    let INSTANCEID = clientInfo.InstanceID;
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    const [isProcessing, setIsProcessing] = useState(false);
    const { id } = useParams();
    const [arrayPayouts, setPayouts] = useState(JSON.parse(localStorage.getItem('arrayPayoutsMethods')).filter(function (element) { return element.PayoutID === id; })[0]);
    const navigate = useNavigate();
    const [OriginalAmount, setOriginalAmount] = useState(0);
    const [Fee, setFee] = useState('');
    const [showForm, setshowForm] = useState(false);
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    // Coinflow withdrawer bank accounts
    const [bankAccounts, setBankAccounts] = useState([]);
    const [selectedBankToken, setSelectedBankToken] = useState('');

    useEffect(() => {
        IsValidToken(localStorage.getItem('Token')).then(
            GetPayoutFee(localStorage.getItem('Token'), arrayPayouts?.PayoutID).then(function (response) {
                var MinFee = parseFloat(response.Authentication.MinFee);
                var PerFee = parseFloat(response.Authentication.PerFee);
                var FlatFee = parseFloat(response.Authentication.FlatFee);

                if (MinFee > 0)
                    setFee(MinFee);
                else if (PerFee > 0)
                    setFee(PerFee + "% ");
                else if (FlatFee > 0)
                    setFee(FlatFee);
            })
        )
            .catch(function (error) {
                navigate('/expired/');
            })

        if (arrayPayouts === undefined) {
            navigate('/payouts/');
        }

        Alerts.ShowMessageLoader('Please wait', 'Please wait while we run verification steps...', 'info');

        // Step 1: verify the customer is registered before showing anything
        setTimeout(() => {
            doCoinflowRegisterUser();
        }, 4000);

    }, [])

    // Step 1: Check that the customer is registered / verified
    async function doCoinflowRegisterUser() {
        swal.close();
        var PayoutData = {
            "Token": localStorage.getItem('Token'),
            "CustomerID": localStorage.getItem('CustomerID'),
            "PayoutName": arrayPayouts.PayoutName
        };
        setIsProcessing(true);
        await CoinflowRegisterUser(PayoutData).then(function (response) {
            var statusCode = response.Authentication.StatusCode;
            var message = response.Authentication.Message;

            if (statusCode === 200) {
                // Registered/verified -> pull the withdrawer bank accounts and show the form
                doCoinflowGetWithdrawer();
            } else if (statusCode === 409) {
                // Conflict Error
                if (isMobile)
                    Alerts.ShowAlertFullScreen('Verification Status', message, 'warning');
                else
                    Alerts.ShowAlert('Verification Status', message, 'warning');
                navigate('/payouts/');
            } else {
                if (isMobile)
                    Alerts.ShowAlertFullScreen('Verification Status', message, 'warning');
                else
                    Alerts.ShowAlert('Verification Status', message, 'warning');
                navigate('/payouts/');
            }
            setIsProcessing(false);
        })
            .catch(function (error) {
                const errorMessage = error?.response?.data?.Authentication?.HtmlResponse
                    || error?.message
                    || 'An unexpected error occurred';
                Alerts.ShowAlert('Verification Status', errorMessage, 'error');
                navigate('/payouts/');
            })
    }

    // Steps 3 + 4: generate the session key (server side) and get the withdrawer bank accounts
    async function doCoinflowGetWithdrawer() {
        var PayoutData = {
            "Token": localStorage.getItem('Token'),
            "CustomerID": localStorage.getItem('CustomerID'),
            "PayoutName": arrayPayouts.PayoutName
        };
        setIsProcessing(true);
        await CoinflowGetWithdrawer(PayoutData).then(function (response) {
            var statusCode = response.Authentication.StatusCode;
            var success = response.Authentication.Success;
            var message = response.Authentication.Message;

            if (statusCode === 200 && success) {
                var accounts = response.Authentication.BankAccounts || [];
                setBankAccounts(accounts);

                if (accounts.length > 0) {
                    // Pre-select the first account so REDEMPTION is enabled by default
                    setSelectedBankToken(accounts[0].Token);
                    setshowForm(true);
                } else {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen('Redemption Status', 'No bank accounts found. Please add a bank account first.', 'warning');
                    else
                        Alerts.ShowAlert('Redemption Status', 'No bank accounts found. Please add a bank account first.', 'warning');
                    navigate('/payouts/');
                }
                forceUpdate();
            } else if (statusCode === 451) {
                // Unavailable for Legal Reasons -> message carries the verification link
                if (isMobile)
                    Alerts.ShowAlertFullScreen('Verification Status', 'Additional verification is required to continue.', 'warning');
                else
                    Alerts.ShowAlert('Verification Status', 'Additional verification is required to continue.', 'warning');
                navigate('/payouts/');
            } else {
                if (isMobile)
                    Alerts.ShowAlertFullScreen('Redemption Status', message || 'We could not load your bank accounts. Please try later.', 'warning');
                else
                    Alerts.ShowAlert('Redemption Status', message || 'We could not load your bank accounts. Please try later.', 'warning');
                navigate('/payouts/');
            }
            setIsProcessing(false);
        })
            .catch(function (error) {
                Alerts.ShowAlert('Redemption Status', 'We could not load your bank accounts. Please try later.', 'error');
                navigate('/payouts/');
            })
    }

    // Step 5: request the payout to the selected bank account
    async function doRequestEWalletPayout(Amount, comments) {
        if (parseFloat(Amount.replace(",", "").replace(" ", "")) <= parseFloat(clientInfo.WithdrawalBalance.replace(",", "")) && parseFloat(Amount.replace(",", "").replace(" ", "")) > 0) {
            var PayoutData = {
                "Token": localStorage.getItem('Token'),
                "Amount": Amount.replace(",", ""),
                "CurrencyCode": clientInfo.CurrencyCode,
                "ProcessorName": arrayPayouts?.PayoutID,
                "EWalletID": selectedBankToken, // bank account token from get-withdrawer
                "SecureID": "",
                "IPv4Address": clientInfo.IPAddress,
                "Comments": comments,
                "Udf1": clientInfo.Udf1
            };

            await RequestEWalletPayout(PayoutData).then(function (response) {
                if (response.Authentication.ErrorCode === "") {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen('Redemption Status', response.Authentication.HtmlResponse.replace(/payout/gi, 'Redemption'), 'info');
                    else
                        Alerts.ShowAlert('Redemption Status', response.Authentication.HtmlResponse.replace(/payout/gi, 'Redemption'), 'info');
                    navigate('/payouts/');
                } else {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen('Redemption Status', response.Authentication.HtmlResponse.replace(/payout/gi, 'Redemption'), 'warning');
                    else
                        Alerts.ShowAlert('Redemption Status', response.Authentication.HtmlResponse.replace(/payout/gi, 'Redemption'), 'warning');
                }
            })
                .catch(function (error) {
                    Alerts.ShowAlert('Redemption Status', 'We were unable to request the redemption. Please try later.', 'error');
                })
        }
        else {
            if (isMobile)
                Alerts.ShowAlertFullScreen('Redemption Status', 'amount not permitted, please check your redemption balance', 'warning');
            else
                Alerts.ShowAlert('Redemption Status', 'amount not permitted, please check your redemption balance', 'warning');
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isProcessing) {
            var data = new FormData(event.target);
            let { amount } = Object.fromEntries(data.entries());

            if (selectedBankToken === '') {
                Alerts.ShowAlert('Warning', 'Please select a bank account', 'warning');
                return;
            }

            if (amount != '') {
                setIsProcessing(true);
                setOriginalAmount(amount);
                await doRequestEWalletPayout(amount, '');
                setIsProcessing(false);
            }
            else {
                Alerts.ShowAlert('Warning', 'Amount required', 'warning');
            }
        }
    }

    return (
        <div className="componentload">
            <form onSubmit={handleSubmit}>
                <div className="row m-4">
                    <span className="icon-single-left txt-primary">
                        <img style={{ width: "100px", height: "100px" }} src={"/svg/" + arrayPayouts?.ImageName + ".svg"} />  <span className="payout-title">Redeem using RTP </span>
                    </span>
                </div>

                {/* Header separator */}
                <div className="row m-4">
                    <div className="col-md-6 col-sm-12">
                        <hr className="mt-3" />
                    </div>
                </div>

                {showForm &&
                    <>
                        {/* Bank account selection (from get-withdrawer) */}
                        <div className="row m-4">
                            <div className="col-md-6 col-sm-12">
                                <label className="payout-subtitle mb-2">Select a bank account</label>
                                {bankAccounts.map((account) => (
                                    <div className="form-check mb-2" key={account.Token}>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="bankAccount"
                                            id={"bank_" + account.Token}
                                            value={account.Token}
                                            checked={selectedBankToken === account.Token}
                                            onChange={(e) => setSelectedBankToken(e.target.value)}
                                        />
                                        <label className="form-check-label" htmlFor={"bank_" + account.Token}>
                                            {account.Alias ? account.Alias : 'Bank account'} &bull;&bull;&bull;&bull; {account.Last4}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Amount */}
                        <div className="row m-4">
                            <div className="col-md-6 col-sm-12">
                                <label className="payout-subtitle mb-2">Amount</label>
                                <input
                                    type="text"
                                    name="amount"
                                    className="form-control"
                                    autoComplete="off"
                                    onKeyPress={onlyNumbers}
                                    placeholder="0.00"
                                />
                                {Fee !== '' &&
                                    <small className="text-muted">Fee: {Fee}</small>
                                }
                            </div>
                        </div>
                    </>
                }

                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12"></div>
                    <div className="col-md-12 mb-3-small mt-4 actionbuttons">
                        <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4" onClick={() => navigate('/payouts/')}>BACK</button>
                        {showForm &&
                            <button type="submit" className="btn btn-deposit btn-deposit-order mb-4 submit">REDEMPTION</button>
                        }
                    </div>
                </div>
            </form>
            <div>
                {isProcessing && <Loading />}
            </div>
        </div>
    );
}
